import Logger from '@/lib/logger';

export type PendingAmplitudeEvent = {
  type: 'event';
  eventName: string;
  eventProperties: Record<string, unknown>;
  time: number;
  adTrackingConsent: boolean;
};

export type PendingAmplitudeOperation = {
  type: 'operation';
  execute: () => void;
  adTrackingConsent: true;
};

export type PendingAmplitudeItem = PendingAmplitudeEvent | PendingAmplitudeOperation;

const MAX_PENDING_AMPLITUDE_ITEMS = 100;
const logger = new Logger('AmplitudeQueue');
const pendingItems: PendingAmplitudeItem[] = [];
let queueOverflowed = false;

export const enqueuePendingAmplitudeItem = (item: PendingAmplitudeItem): void => {
  if (pendingItems.length >= MAX_PENDING_AMPLITUDE_ITEMS) {
    pendingItems.shift();
    if (!queueOverflowed) {
      logger.warn(
        `[AmplitudeQueue] Pending queue exceeded ${MAX_PENDING_AMPLITUDE_ITEMS}; dropping oldest items`
      );
      queueOverflowed = true;
    }
  }

  pendingItems.push(item);
};

export const drainPendingAmplitudeItems = (): PendingAmplitudeItem[] => {
  const drainedItems = pendingItems.splice(0);
  queueOverflowed = false;

  return drainedItems;
};

export const discardPendingAmplitudeItems = (
  shouldDiscard?: (item: PendingAmplitudeItem) => boolean
): void => {
  if (shouldDiscard) {
    const retainedItems = pendingItems.filter((item) => !shouldDiscard(item));
    pendingItems.splice(0, pendingItems.length, ...retainedItems);
  } else {
    pendingItems.length = 0;
  }

  if (pendingItems.length < MAX_PENDING_AMPLITUDE_ITEMS) {
    queueOverflowed = false;
  }
};
